<template>
  <div class="container_TransferenciasPublicas">
    <PCard>
      <div class="filter_TransferenciasPublicas">
        <PButton @click="verExportar" icon="IconExcel" variant="secondary">{{
          $t("action.export")
        }}</PButton
        ><TransferenciasExportacion
          v-if="verModalExportar"
          :optionsClientes="optionsClientes"
          :textActionName="titleModalExportar"
          :verModalExportar="verModalExportar"
          @closeExportar="closeExportar"
        ></TransferenciasExportacion>
        <PSidebar
          v-model="mostrarFiltros"
          :title="$t('label.filtros')"
          icon="IconFilter"
          bVariant="secondary"
          :textButton="dameTextoBotonFiltros"
        >
          <TransferenciasPublicasFiltersForm
            :transportadorasOptions="transportadorasOptions"
            v-model="filters"
            actionName="filtrar"
            :textActionName="$t('label.filtrar')"
            @action="action"
            @cancel="action"
          >
          </TransferenciasPublicasFiltersForm>
        </PSidebar>
      </div>
      <QuickFilter v-model="quickFilter" @change="action" />
      <div class="datas_TransferenciasPublicas">
        <PColapsable
          variant="yellow"
          v-for="(tipo, index) in quickFilter.tipos"
          :key="index + 'tipo'"
        >
          <template #title>
            {{ tipo === "OFERTA" ? $t("label.ofertas") : $t("label.demandas") }}
          </template>
          <div v-for="(data, index) in transferencias(tipo)" :key="index + 'datas'">
            <TransferenciasPublicasTable
              v-model="data.pagination"
              :tipo="data.tipo"
              :divisa="data.divisa"
              :transferencias="data.transferencias"
              :cantidadDisponible="data.cantidadDisponible"
              :columnsConfig="tipo === 'OFERTA' ? publicasOfertasConfig : publicasDemandasConfig"
              v-if="data.transferencias.length > 0"
              :total-elements="data.totalElements"
              @change="action"
              @demandarSobreOferta="action"
              @ofertarSobreDemanda="action"
            ></TransferenciasPublicasTable>
          </div>
        </PColapsable>
      </div>
    </PCard>

    <PModal
      :show="verModal"
      @close="verModal = false"
      :closeClickExit="false"
      :title="titleModal"
      :showCloseIcon="false"
    >
      <DemandarSobreOferta
        :oferta="datosDemandarSobreOferta.oferta"
        :divisa="datosDemandarSobreOferta.divisa"
        v-if="verDemandarSobreOferta"
        @action="action"
        @cancel="cerrarDemandarSobreOferta"
      ></DemandarSobreOferta>
      <OfertarSobreDemanda
        :demanda="datosOfertarSobreDemanda.demanda"
        :divisa="datosOfertarSobreDemanda.divisa"
        v-if="verOfertarSobreDemanda"
        @action="action"
        @cancel="cerrarOfertarSobreDemanda"
      ></OfertarSobreDemanda>
    </PModal>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import TransferenciasPublicasFiltersForm from "./TransferenciasPublicasFiltersForm.vue";
import TransferenciasPublicasTable from "./TransferenciasPublicasTable.vue";
import TransferenciasExportacion from "@/pages/transferencias/common/TransferenciasExportacion.vue";
import DemandarSobreOferta from "./DemandarSobreOferta.vue";
import OfertarSobreDemanda from "./OfertarSobreDemanda.vue";
import { Action, Getter } from "vuex-class";
import {
  EDirection,
  IColumnaResponse,
  IDemandaParams,
  IOfertaParams,
  IPaged,
  ITransferenciaFilter,
  ITransferenciasData,
} from "@/services";
import {
  Divisa,
  ICliente,
  IDemanda,
  IDivisa,
  IOferta,
  IOfertaDemanda,
  ITransportadora,
} from "@/entities";
import QuickFilter from "@/pages/transferencias/common/QuickFilter.vue";
import { iniQuickFilter, IQuickFilter } from "@/pages/transferencias/types/quickFilter.types";
import { EventBus } from "@/event-bus";
import { ITransferenciasAll } from "@/pages/transferencias/types";
import VueMethods from "@/vue-methods";

@Component({
  mixins: [VueMethods],
  components: {
    TransferenciasPublicasFiltersForm,
    TransferenciasPublicasTable,
    TransferenciasExportacion,
    DemandarSobreOferta,
    OfertarSobreDemanda,
    QuickFilter,
  },
})
export class TransferenciasPublicas extends Vue {
  @Prop({ required: true }) publicasOfertasConfig!: IColumnaResponse;
  @Prop({ required: true }) publicasDemandasConfig!: IColumnaResponse;
  @Prop({ required: true }) transportadorasOptions!: ITransportadora[];
  @Getter("getClientesAll") getClientes!: ICliente[];
  @Getter("getDivisas") getDivisas!: IDivisa[];
  @Getter("getClienteXDivisa") getClienteXDivisa!: IDivisa[];
  @Action("fetchPublicas") fetchPublicas!: (
    params: ITransferenciaFilter
  ) => Promise<ITransferenciasData | undefined>;
  @Action("saveDemanda") saveDemanda!: (params?: IDemandaParams) => Promise<IDemanda | undefined>;
  @Action("saveOferta") saveOferta!: (params?: IOfertaParams) => Promise<IOferta | undefined>;
  @Action("setClienteSelected") setClienteSelected!: (cliente?: ICliente) => void;

  datosDemandarSobreOferta: { oferta: Partial<IOfertaDemanda>; divisa: IDivisa } = {
    oferta: {},
    divisa: new Divisa(),
  };
  datosOfertarSobreDemanda: { demanda: Partial<IOfertaDemanda>; divisa: IDivisa } = {
    demanda: {},
    divisa: new Divisa(),
  };
  fecExpOk = false;
  verDemandarSobreOferta = true;
  verOfertarSobreDemanda = false;
  verModal = false;
  titleModal = "";
  verModalExportar = false;
  titleModalExportar = "";
  mostrarFiltros = false;
  filters: any = {
    delegationsSelected: [],
    pkCoste: [],
    denominacionesSelected: [],
    transportadorasSelected: [],
  };
  quickFilter: IQuickFilter = iniQuickFilter;
  get dameTextoBotonFiltros(): string {
    let numFiltros = 0;
    Object.keys(this.filters).forEach((key: string) => {
      if (this.filters[key] != "" && this.filters[key] != null) {
        numFiltros = numFiltros + 1;
      }
    });

    return numFiltros ? `(${numFiltros}) ${this.$t("label.filtros")}` : this.$t("label.filtros");
  }

  queryParams = this.$route.query;
  params: ITransferenciaFilter = {
    pkCliente: this.queryParams.pkCliente ? Number(this.queryParams.pkCliente) : undefined,
    tipo: this.queryParams.tipo?.toString(),
    delegaciones: this.queryParams.delegaciones
      ?.toString()
      .split(",")
      .map((pk) => Number(pk)),
    denominaciones: this.queryParams.denominaciones
      ?.toString()
      .split(",")
      .map((pk) => Number(pk)),
    transportadoras: this.queryParams.transportadoras
      ?.toString()
      .split(",")
      .map((pk) => Number(pk)),
    estado: this.queryParams.estado?.toString().split(","),
  };

  transferenciasAll: ITransferenciasAll[] = [];
  optionsClientes: ICliente[] = [];

  verExportar(): void {
    this.verModalExportar = true;
    this.titleModalExportar = this.$t("action.export");
  }

  closeExportar(): void {
    this.verModalExportar = false;
  }

  transferencias(tipo: "OFERTA" | "DEMANDA"): ITransferenciasAll[] {
    let result: ITransferenciasAll[] = [];
    const filtradoPorTipo = this.transferenciasAll.filter((data) => data.tipo === tipo);
    //filtramos por divisas seleccionadas
    this.quickFilter.divisas.forEach((divisa) => {
      const filtradoPorDivisas = filtradoPorTipo.filter((data) => data.divisa.codDivisa === divisa);
      result = result.concat(filtradoPorDivisas);
    });
    return result;
  }
  cerrarOfertarSobreDemanda(): void {
    this.verModal = false;
    this.verOfertarSobreDemanda = false;
  }
  cerrarDemandarSobreOferta(): void {
    this.verModal = false;
    this.verDemandarSobreOferta = false;
  }
  checkClient(): void {
    if (!this.getClientes.find((c) => c.id === Number(this.params.pkCliente))) {
      this.params.pkCliente = undefined;
    }
  }
  async getPublicas(
    tipo: "OFERTA" | "DEMANDA",
    divisa: IDivisa,
    pagination: IPaged
  ): Promise<ITransferenciasData | undefined> {
    this.checkClient();
    const params: ITransferenciaFilter = { ...this.params };
    params.pkDivisa = divisa.id;
    params.tipo = tipo;
    params.page = pagination.page! - 1;
    params.size = pagination.size;
    params.orderBy = pagination.orderBy;
    params.direction = pagination.direction;
    return await this.fetchPublicas(params);
  }
  cargarTodosDatos(): void {
    this.transferenciasAll = [];
    this.getClienteXDivisa.forEach(async (divisa) => {
      await this.cargarDatos("OFERTA", divisa);
      await this.cargarDatos("DEMANDA", divisa);
    });
  }
  async cargarDatos(tipo: "OFERTA" | "DEMANDA", divisa: IDivisa): Promise<void> {
    const transferecias: ITransferenciasAll | undefined = this.transferenciasAll.find(
      (trans) => trans.tipo === tipo && trans.divisa.codDivisa === divisa.codDivisa
    );
    if (transferecias) {
      //Como ya existe cargamos los datos nuevos
      const response: ITransferenciasData | undefined = await this.getPublicas(
        tipo,
        divisa,
        transferecias.pagination
      );
      if (response) {
        transferecias.transferencias = response.transferencias.content;
        transferecias.pagination.totalElements = response.transferencias.totalElements;
        transferecias.cantidadDisponible = response.cantidadDisponible;
      }
    } else {
      const pagination: IPaged = {
        direction: EDirection.DESC,
        orderBy: "fecCrear",
        page: 1,
        size: 10,
      };

      //Aqui se inicializa si no existe lo datos de tipo y divisa
      const response: ITransferenciasData | undefined = await this.getPublicas(
        tipo,
        divisa,
        pagination
      );

      if (response) {
        pagination.totalElements = response.transferencias.totalElements;
        this.transferenciasAll.push({
          tipo: tipo,
          divisa: divisa,
          transferencias: response.transferencias.content,
          cantidadDisponible: response.cantidadDisponible,
          pagination: pagination,
          totalElements: response.transferencias.totalElements,
        });
      }
    }
  }
  async actionDemandarSobreOferta(action: { action: string; data?: any }): Promise<void> {
    if (action.action === "demandarSobreOferta") {
      this.fecExpOk = false;
      this.datosDemandarSobreOferta.oferta = action.data.oferta;
      this.datosDemandarSobreOferta.divisa = action.data.divisa;
      this.verModal = true;
      this.titleModal = this.$t("title.modal.transfer.public.demand");
      this.verDemandarSobreOferta = true;
      this.verOfertarSobreDemanda = false;
      if (
        this.datosDemandarSobreOferta.oferta.fecExpirar !== undefined &&
        new Date(this.datosDemandarSobreOferta.oferta.fecExpirar) >= new Date()
      ) {
        this.fecExpOk = true;
      }
    } else if (action.action === "demandarSobreOfertaConfirmed") {
      if (
        this.fecExpOk &&
        action.data.fecExpirar !== undefined &&
        action.data.fecExpirar < new Date()
      ) {
        this.$swal({
          icon: "error",
          title: this.$t("error"),
          html: this.$t("label.oferta.expirada"),
        });
      } else {
        const res = await this.saveDemanda(action.data);

        const clienteHasAprobacionAutomaticaOferta = action.data.hasAprobacionAutomatica;

        if (res) {
          this.cargarTodosDatos();
          this.verModal = false;
          this.titleModal = "";
          if (clienteHasAprobacionAutomaticaOferta) {
            EventBus.$emit("p-toast", {
              variant: "success",
              message: this.$t("label.demanda.guardada.aprobacion.automatica"),
            });
          } else {
            EventBus.$emit("p-toast", {
              variant: "success",
              message: this.$t("label.demanda.guardada"),
            });
          }
        } else {
          EventBus.$emit("p-toast", { variant: "danger", message: res });
        }
      }
    }
  }
  async actionOfertarSobreDemanda(action: { action: string; data?: any }): Promise<void> {
    this.fecExpOk = false;
    if (action.action === "ofertarSobreDemanda") {
      this.datosOfertarSobreDemanda.demanda = action.data.demanda;
      this.datosOfertarSobreDemanda.divisa = action.data.divisa;

      this.verModal = true;
      this.titleModal = this.$t("label.transferir");
      this.verDemandarSobreOferta = false;
      this.verOfertarSobreDemanda = true;
      if (
        this.datosOfertarSobreDemanda.demanda.fecExpirar !== undefined &&
        new Date(this.datosOfertarSobreDemanda.demanda.fecExpirar) >= new Date()
      ) {
        this.fecExpOk = true;
      }
    } else if (action.action === "ofertarSobreDemandaConfirmed") {
      if (
        this.fecExpOk &&
        action.data.fecExpirar.fecExpirar !== undefined &&
        action.data.fecExpirar < new Date()
      ) {
        this.$swal({
          icon: "error",
          title: this.$t("error"),
          html: this.$t("label.demanda.expirada"),
        });
      } else {
        const res = await this.saveOferta(action.data);

        if (res) {
          this.cargarTodosDatos();
          this.verModal = false;
          this.titleModal = "";
          EventBus.$emit("p-toast", {
            variant: "success",
            message: this.$t("label.oferta.guardada"),
          });
        } else {
          EventBus.$emit("p-toast", { variant: "danger", message: res });
        }
      }
    }
  }

  actionQuickFilter(action: { action: string; data?: any }): void {
    if (action.action === "quickFilter_cliente") {
      //llamaremos con el filtro del cliente

      if (action.data.cliente == -1) {
        this.params.pkCliente = undefined;
      } else {
        this.params.pkCliente = action.data.cliente;
      }
      this.cargarTodosDatos();
    } else if (action.action === "quickFilter_divisa") {
      //lo dejo por si hay que hacer alguna accion a futuro
    } else if (action.action === "quickFilter_tipo") {
      //lo dejo por si hay que hacer alguna accion a futuro
    } else if (action.action === "quickFilter_denominaciones") {
      const denom = action.data.denominaciones ?? [];
      const actuales = this.params.denominaciones ?? [];
      if (denom.length === actuales.length && denom.every((d: number) => actuales.includes(d)))
        return;
      this.params.denominaciones = [...denom];
      this.cargarTodosDatos();
    }
    this.params.page = 1;
  }

  async action(action: { action: string; data?: any }): Promise<void> {
    if (action.action === "print") {
      alert("print");
    } else if (action.action === "download") {
      alert("download");
    } else if (action.action === "filtrar" || action.action === "clean") {
      this.params.page = 1;
      this.params.delegaciones = this.filters.delegationsSelected ?? undefined;
      this.params.transportadoras = this.filters.transportadorasSelected ?? undefined;
      this.params.pkCoste = this.filters.pkCoste ?? undefined;
      this.params.calidadesDenominacion = this.filters.denominacionesSelected ?? undefined;
      this.cargarTodosDatos();
      this.mostrarFiltros = false;
    } else if (action.action === "changeTable") {
      await this.cargarDatos(action.data.tipo, action.data.divisa);
    }
    this.actionQuickFilter(action);
    await this.actionDemandarSobreOferta(action);
    await this.actionOfertarSobreDemanda(action);
  }
  mounted(): void {
    this.getClienteXDivisa.forEach((divisa) => {
      if (this.quickFilter.divisas.findIndex((div) => div === divisa.codDivisa) < 0)
        this.quickFilter.divisas.push(divisa.codDivisa);
    });
    this.optionsClientes = this.getClientes.slice();
  }
}
export default TransferenciasPublicas;
</script>
<style scoped>
.filter_TransferenciasPublicas {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  @media (min-width: 681px) {
    float: right;
  }
}
</style>
